<script setup lang="ts">
defineProps({
  label: {
    type: String,
    default: "",
  },
  modelValue: {
    type: [String, Number],
    default: "",
  },
  value: {
    type: [String, Number],
    required: true,
  },
});
</script>

<template>
  <label v-if="label" class="flex flex-row">
    <div>
      <input
        type="radio"
        class="py-2 mr-3"
        :checked="modelValue === value"
        :value="value"
        v-bind="$attrs"
        @change="$emit('update:modelValue', value)"
      />
    </div>
    <span>{{ label }}</span>
  </label>
</template>
